var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('v-main',[_c('v-app',{attrs:{"light":""}},[_c('core-toolbar'),_c('core-drawer'),_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{staticClass:"grey lighten-5"})],1),(_vm.displayFooter())?_c('core-footer'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }